let rmoFormSelection = document.getElementById('rmo-form');
window.rmoGlobalElementObject = {};
if (Boolean(rmoFormSelection)) {
     let moneyOrderNumberEL =  rmoFormSelection.querySelector("#moneyOrderNumber");
    let moneyOrderAmountEL =  rmoFormSelection.querySelector("#moneyOrderAmount");

    moneyOrderNumberEL?.addEventListener('input', (e) => {
      const value = e?.target?.value
      if(!(/^\d+$/.test(value))){
        rmoGlobalElementObject.showValidationMessage(moneyOrderNumberEL, 'number-only-error-message')
      }else if(value?.length !== 11) {
        rmoGlobalElementObject.showValidationMessage(moneyOrderNumberEL, 'min-max-error-message')
      } else {
        rmoGlobalElementObject.hideValidationMessage(moneyOrderNumberEL);
      }
    })

    moneyOrderAmountEL?.addEventListener('input', (e) => (
      (/^\d{0,6}(\.\d{0,2})?$/.test(e.target.value))
        ? rmoGlobalElementObject.hideValidationMessage(moneyOrderAmountEL)
        : rmoGlobalElementObject.showValidationMessage(moneyOrderAmountEL)
    ))

    rmoGlobalElementObject.openDropDown = function(event, setFocusTarget) {
        let moreButton = document.querySelector(".icon-0024_dropdown-more");
        moreButton.classList.toggle("down");
        // Handy vars for various menu dom nodes and IDs.
        var menuId = event.currentTarget.getAttribute('aria-controls');    // this is the ID of the UL. JJ IMPROVING.. call this menuId
        var menu = document.getElementById(menuId);   // this is the UL.  JJ IMPROVING.. call this menu
        var controllerInputID = menu.getAttribute('aria-labelledby'); // needed for proper closure of menu and returning focus to controlling Input.
        var menuContainerId = menu.parentNode.id; // This is the id of the div that contains the UL. Needed for proper menu closure.  wuds-is-open, wuds-is-closed is applied to it.
        var dropdownToOpen = document.getElementById(menuContainerId);   // This is the dom element div that contains the UL. Needed for proper menu closure.  wuds-is-open, wuds-is-closed is applied to it.
      
        // Begin Adding Toggle effect - want to have dropdown such that if user clicks it once it opens and clicking again will close it.
        // but support the case where they may click to open and then use a keypress to get to the menu item
         // see what the event key code was. If it was Key Down or Key Up or other Atria - then do not close the menu. They may have been hitting e.g. Down Arrow to move focus to first item
         var preserveOpenState = false;
         if (event.keyCode) { // if user pressed a key do not close the dropdown. It should be false if user clicked it. Really only want a convenience Toggle off the user clicks it open. Then can click to close.
           preserveOpenState = true;
          //  console.log('***** Leaving menu visible. User probably using Key interactions again on the Input after it is open  ******')
         }
      
        // first check if it's closed. If it is then open it. Also if user has done a key down in the Input.
        if (dropdownToOpen.classList.contains("wuds-is-closed") || preserveOpenState) {   // THIS IS THE TOGGLE ON 
      
          // console.log('***** TOGGLING MENU ON ******')
      
          // see if there is a modal version of the dropdown to open - this is expected for Country Dropdown
          var isMobileModal = document.getElementById(menuContainerId+'-modal');
      
        //   if (breakpointDeviceInUse.value == 'S-size-device' && isMobileModal) { // open the modal which presumes and relies on id being same as that of targetDropdown except with "-modal" appended to it
        //     // console.log('S-size-device breakpoint so open modal');
        //     dropdownToOpen = document.getElementById(menuContainerId+'-modal');
        //   }
      
          // now show the Dropdown (and focus should be on matched element)
          dropdownToOpen.classList.remove("wuds-is-closed"); // remove inactive border color
          dropdownToOpen.classList.add("wuds-is-open");
      
          // See  if need to set focus
          if (setFocusTarget) {
      
            if (setFocusTarget == 'focusOnFirst') {
      
              var popupMenuFirstItem = menu.firstElementChild;
              var popupMenuFirstItemAnchor = popupMenuFirstItem.firstElementChild; // assumes anchor is first child
              popupMenuFirstItemAnchor.focus();
      
            } else if (setFocusTarget == 'focusOnLast') {
      
              var popupMenuLastItem = menu.lastElementChild;
              var popupMenuLastItemAnchor = popupMenuLastItem.firstElementChild; // assumes anchor is first child
              popupMenuLastItemAnchor.focus();
      
            }
          }
      
          // lastly set the aria-expanded="true"    for the Input controller of the menu
          event.currentTarget.setAttribute('aria-expanded',true);
      
          console.log('Inside openPseudoDropdown');
      
        }  else {
      
            console.log('***** TOGGLING MENU OFF ******')
            rmoGlobalElementObject.closeDropdown(menuContainerId, controllerInputID);  // close menu, return focus to controlling Input
      
        }
      
    }
      rmoGlobalElementObject.closeDropdown = function (targetDropdownId, inputToUpdateId) {
        var dropdown = document.getElementById(targetDropdownId);
        dropdown.classList.add("wuds-is-closed"); 
        dropdown.classList.remove("wuds-is-open"); 
        var cancelIcon = document.getElementsByClassName("wuds-dropdown__search__cancel__icon");
        if(cancelIcon[0]){ cancelIcon[0].classList.add("d-none");}
        // lastly set the aria-expanded="false"    for the Input controller of the menu and place focus on the Input
        var targetInput = document.getElementById(inputToUpdateId);
        targetInput.setAttribute('aria-expanded',false);
      
        var controllerInput = document.getElementById(inputToUpdateId);
        controllerInput.focus();
      }
      rmoGlobalElementObject.justcloseDropdown = function (targetDropdownId, inputToUpdateId) {
        var dropdown = document.getElementById(targetDropdownId);
        dropdown?.classList.add("wuds-is-closed"); 
        dropdown?.classList.remove("wuds-is-open"); 
        var cancelIcon = document.getElementsByClassName("wuds-dropdown__search__cancel__icon");
        if(cancelIcon[0]){ cancelIcon[0].classList.add("d-none");}
        // lastly set the aria-expanded="false"    for the Input controller of the menu and place focus on the Input
        var targetInput = document.getElementById(inputToUpdateId);
        targetInput.setAttribute('aria-expanded',false);
      }
      rmoGlobalElementObject.handleKeydownOnInput = function  (event, specialMenu) {

        var keyCodeObj = Object.freeze({
          'TAB': 9,
          'RETURN': 13,
          'ESC': 27,
          'SPACE': 32,
          'PAGEUP': 33,
          'PAGEDOWN': 34,
          'END': 35,
          'HOME': 36,
          'LEFT': 37,
          'UP': 38,
          'RIGHT': 39,
          'DOWN': 40
        });
      
        // SEE IF IT CONTROLS MENU
        // IF SO - call function that opens the menu and places focus at first position
        var popupMenuExists = event.currentTarget.getAttribute('aria-controls');
      
        if (popupMenuExists) {  // IF popup menu exists then determine key pressed and what to do for it
      
          var flag = false;
      
          switch (event.keyCode) { // see if the keycode matches a value of interest in keyCode object of interesting values.
            case keyCodeObj.SPACE:
            case keyCodeObj.RETURN:
            case keyCodeObj.DOWN:   
                 var result = rmoGlobalElementObject.openDropDown(event, 'focusOnFirst');
                 flag = true;
              break;
      
            case keyCodeObj.UP:
                 var result = rmoGlobalElementObject.openDropDown(event, 'focusOnLast'); 
                 flag = true;
              break;
      
            default:
              break;
          }
      
          if (flag) {
            event.stopPropagation();
            event.preventDefault();
          }
        }
      };
      rmoGlobalElementObject.setInputAnswer = function (event) {
        // Relying on knowing markup structure to traverse up to find key parent elements etc. 
        // Update Input with selected value
        var answer = event.currentTarget.querySelector("span").innerHTML; // anchor child is span. Inner html of span we will use as answer.
        var answerKeyValue = event.currentTarget.getAttribute("data-keyvalue");
        var currentListItem = event.currentTarget.parentNode; // Anchor's Parent  is LI. As the user clicks that Lists items Anchor. To drive e.g. previous/next item navigation will need this.
        var menu = currentListItem.parentNode; // LI's parent is  UL 
        var controllerInputId = menu.getAttribute('aria-labelledby'); // ID of Controlling Input is handily in Aria attribute. 
        var menuContainerId = menu.parentNode.getAttribute('id'); // UL's parent is the container div we update to either "wuds-is-closed" or "wuds-is-open".
        var controllerInputElementId = document.getElementById(controllerInputId);
        if(controllerInputElementId){
            controllerInputElementId.value = answer;
            controllerInputElementId.setAttribute("data-value",answer);
            if(answerKeyValue && answerKeyValue != null && answerKeyValue !== ""){
              controllerInputElementId.setAttribute("data-keyvalue",answerKeyValue);
            }
            rmoGlobalElementObject.hideValidationMessage(controllerInputElementId);
        }
        // special case though is Mobile where it's a modal so need to close this: country-11-dropdown-modal and not this: country-11-dropdown-modal-dropdown
        // going to strip off "-dropdown" IF 'modal-dropdown' is part of the classname.
        var isMobileModal = menuContainerId.indexOf('modal-dropdown') !== -1;
        if (isMobileModal) {
          menuContainerId = menuContainerId.replace('modal-dropdown','modal');
        }
      
        rmoGlobalElementObject.closeDropdown(menuContainerId, controllerInputId);
    }
    rmoGlobalElementObject.setFocusToPreviousMenuItem = function (currentListItem) {
        var previousListItem = currentListItem.previousElementSibling;
      
        if (previousListItem) {
          var previousItemAnchor = previousListItem.firstElementChild;
          if (previousItemAnchor) {
            previousItemAnchor.focus();
          }
        } else {
          // must be first item. So find parent UL and go to last child's anchor. 
          var parentUL = currentListItem.parentNode;
          var popupMenuLastItem = parentUL.lastElementChild;
          var popupMenuLastItemAnchor = popupMenuLastItem.firstElementChild; // assumes anchor is first child
          popupMenuLastItemAnchor.focus();
        }
      
      
      }
      
      // helper function for dropdown menu interaction
      // determine next menu item and place focus on it.
      // if there is no next item then place focus on first menu item.
      // @param currentListItem - dom node of current List Item (the LI). The menu construct is assumed to be UL with LI child elements that each have one Anchor child - that has the click and keypress events
      rmoGlobalElementObject.setFocusToNextMenuItem = function (currentListItem) {
      
        // user clicked the anchor inside the LI item.  So try to find next LI item and if it exists then it's child anchor and place focus on it
      
        var nextListItem = currentListItem.nextElementSibling;
      
        if (nextListItem) {
          var nextItemAnchor = nextListItem.firstElementChild;
          if (nextItemAnchor) {
            nextItemAnchor.focus();
          }
        } else {
          // must be last item. So find parent UL and go to first child's anchor. 
          var parentUL = currentListItem.parentNode;
          var popupMenuFirstItem = parentUL.firstElementChild;
          var popupMenuFirstItemAnchor = popupMenuFirstItem.firstElementChild; // assumes anchor is first child
          popupMenuFirstItemAnchor.focus();
        }
      
      }
      
      // used for PAGEDOWN keydown
      // @param menu dom node of the UL menu
      rmoGlobalElementObject.setFocusToFirstMenuItem = function (menu) {
        var popupMenuFirstItem = menu.firstElementChild;
        var popupMenuFirstItemAnchor = popupMenuFirstItem.firstElementChild; // assumes anchor is first child
        popupMenuFirstItemAnchor.focus();
      }
      
      // used for PAGEDOWN keydown
      // @param menu dom node of the UL menu
      rmoGlobalElementObject.setFocusToLastMenuItem = function (menu) {
        var popupMenuLastItem = menu.lastElementChild;
        var popupMenuLastItemAnchor = popupMenuLastItem.firstElementChild; // assumes anchor is first child of the lI
        popupMenuLastItemAnchor.focus();
      }
      
      // this can be implemented as well by setting a global variable for lastFocusedInput for example when the user presses key in the input. The key press handler can set it. Then just reference that to return
      // focus to the controlling input.
      // In this example -we leverage the fact that the Aria Labeled By (aria-labelledby) attribute of the UL list is the ID of the controlling input to place focus on.
      // @param currentListItem dom node of current List Item (the LI).
      rmoGlobalElementObject.setFocusToController = function (currentListItem) {
        var controllerInputID = currentListItem.getAttribute('aria-labelledby');
        document.getElementById(controllerInputID).focus();
      }
      rmoGlobalElementObject.dropDownSearchKeyUpEventHandler = function (event) {
        var searchInput = event.currentTarget.value;
        var menuId = event.currentTarget.getAttribute('aria-controls');
        var menu = document.getElementById(menuId); 
        var menuListitems = menu.querySelectorAll(".wuds-dropdown__item");
        
        for (let i = 0; i <= menuListitems.length - 1; i++) {
          //console.log(menuListitems[i].getElementsByClassName("dropdown-lists-span"));
          let title = menuListitems[i].getElementsByClassName("dropdown-lists-span")[0].innerText
          //console.log(title);
          if (title.toUpperCase().indexOf(searchInput.toUpperCase()) > -1) {
            menuListitems[i].style.display = "";    
          } else {
            menuListitems[i].style.display = "none";
          }
        }
      }
    rmoGlobalElementObject.handleKeydownOnMenuItem = function  (event) {

        var keyCodeObj = Object.freeze({
          'TAB': 9,
          'RETURN': 13,
          'ESC': 27,
          'SPACE': 32,
          'PAGEUP': 33,
          'PAGEDOWN': 34,
          'END': 35,
          'HOME': 36,
          'LEFT': 37,
          'UP': 38,
          'RIGHT': 39,
          'DOWN': 40
        });
      
        var flag = false;
      
        // Handy vars for various menu dom nodes and IDs.
        var currentListItem = event.currentTarget.parentNode; // handy to know what the current list item is. As the user clicks that Lists items Anchor. To drive e.g. previous/next item navigation will need this.
        var currentListItemAnchor = event.currentTarget; // this assumes all our click events are on the anchor tag within list item.
      
        var menu = currentListItem.parentNode; // this is the UL.
        var menuContainerId =menu.parentNode.id; // This is the id of the div that contains the UL. Needed for proper menu closure.  wuds-is-open, wuds-is-closed is applied to it.
        var controllerInputID = menu.getAttribute('aria-labelledby'); // needed for proper closure of menu and returning focus to controlling Input.
      
        switch (event.keyCode) {
          case keyCodeObj.SPACE:
            flag = true;
            break;
      
          case keyCodeObj.RETURN:
            currentListItemAnchor.click(); // trigger the click event - and the listener for that will fire. 
            flag = true;
            break;
      
          case keyCodeObj.ESC:
            rmoGlobalElementObject.closeDropdown(menuContainerId, controllerInputID);  // close menu, return focus to controlling Input
            flag = true;
            break;
      
          case keyCodeObj.UP:
            rmoGlobalElementObject.setFocusToPreviousMenuItem(currentListItem);  // put focus on previous menu item (the previous LI's anchor element)
            flag = true;
            break;
      
          case keyCodeObj.DOWN:
            rmoGlobalElementObject.setFocusToNextMenuItem(currentListItem);   // put focus on next menu item (the next LI's anchor element)
            flag = true;
            break;
      
          case keyCodeObj.HOME:
          case keyCodeObj.PAGEUP:
            rmoGlobalElementObject.setFocusToFirstMenuItem(menu);   // put focus on first menu item (the next LI's anchor element)
            flag = true;
            break;
      
          case keyCodeObj.END:
          case keyCodeObj.PAGEDOWN:
            rmoGlobalElementObject.setFocusToLastMenuItem(menu);   // put focus on last menu item (the next LI's anchor element)
            flag = true;
            break;
      
          case keyCodeObj.TAB:
            rmoGlobalElementObject.closeDropdown(menuContainerId, controllerInputID);  // close menu, return focus to controlling Input
            // this.popupMenu.setFocusToController();
            // this.popupMenu.close(true);
            break;
      
          default:
            // if (isPrintableCharacter(char)) {
            //   this.popupMenu.setFocusByFirstCharacter(this, char);
            // }
            break;
        }
      
        if (flag) {
          event.stopPropagation();
          event.preventDefault();
        }
      }
      
    const setDropDownEventListeners = () => {
        let dropDownArray = rmoFormSelection.getElementsByClassName("wu-input--dropdown");
        Array.from(dropDownArray).forEach(function(element) {

            element.addEventListener("click", function() { 
                rmoGlobalElementObject.openDropDown(event); 
            });
        
            // element.addEventListener("keydown", function() { 
            //     rmoGlobalElementObject.handleKeydownOnInput(event); 
            // });

            // element.addEventListener("keyup", function() { 
            //   rmoGlobalElementObject.dropDownSearchKeyUpEventHandler(event); 
            // });
        
          }); 
          var wuDropdownMenuItems =  rmoFormSelection.getElementsByClassName("wuds-dropdown__item");

          Array.from(wuDropdownMenuItems).forEach(function(element) {
        
            // only add event listener if the item does not have "wuds-dropdown__item--disabled"
            if ( element.classList.contains("wuds-dropdown__item--disabled") ) {
              //do nothing - don't add listener
            } else {
              // find first anchor within it
              var anchor = element.querySelector("a");
        
              anchor.addEventListener("click", function() { 
                rmoGlobalElementObject.setInputAnswer(event); 
              });
        
              anchor.addEventListener("keydown", function() { 
                rmoGlobalElementObject.handleKeydownOnMenuItem(event);
              });
            }
        
          }); // end loop through elements that matched on class name
          var ip = rmoFormSelection.querySelectorAll(".wu-input");
          rmoFormSelection.addEventListener("DOMContentLoaded", stat);

          for (var i = 0; i < ip.length; i++) {
            if (ip[i].addEventListener) {
              ip[i].addEventListener("change", stat);
              ip[i].addEventListener("blur", stat);
            } else if (ip[i].attachEvent) {
              ip[i].attachEvent("change", stat);
              ip[i].attachEvent("blur", stat);
            }
          }

          function stat() {
            for (var i = 0; i < ip.length; i++) {
              if (ip[i].value != '') {
                ip[i].classList.add("wu-input--is-focus");
              } else if (ip[i].value == '') {
                ip[i].classList.remove("wu-input--is-focus");
              }
            }
          }
          rmoFormSelection.addEventListener("click", function(e){
              if (e.target.parentNode.classList && e.target.parentNode.classList.value && e.target.parentNode.classList.value.indexOf('wuds-dropdown') === -1
              && e.target.parentNode.classList.value.indexOf('wu-input--dropdown') == -1) {
                // rmoGlobalElementObject.justcloseDropdown("languageDropDown-dropdown","languageDropDown");
                rmoGlobalElementObject.justcloseDropdown("purchasedState-dropdown","purchasedState");
                rmoGlobalElementObject.justcloseDropdown("purchaserState-dropdown","purchaserState");
              }
            
          });

    }
    const setDatePickers = () =>{
        var today = new Date(); 
        var startDateSet = new Date();
        startDateSet.setFullYear(startDateSet.getFullYear() - 10);
        jQuery( "#datePurchased" ).datepicker({
          showAnim: "slideDown",
          changeMonth: true,
          changeYear : true,
          startDate:startDateSet,
          endDate:today,
          maxDate: 0,
          onSelect: function() {
            let fromDateElementObject = document.getElementById('datePurchased');
            fromDateElementObject.classList.add("wu-input--is-focus");
            rmoGlobalElementObject.hideValidationMessage(fromDateElementObject);
         }
        });
        jQuery( "#signDate" ).datepicker({
          showAnim: "slideDown",
          changeMonth: true,
          changeYear : true,
          endDate:today,
          maxDate: 0,
          onSelect: function() {
            let toDateElementObject = document.getElementById('signDate');
            toDateElementObject.classList.add("wu-input--is-focus");
            rmoGlobalElementObject.hideValidationMessage(toDateElementObject);
         }
        });
        
    }
    rmoGlobalElementObject.showValidationMessage  = function  (targetElement, attribute) {
      targetElement.parentNode.classList.add('wu-input__error');
      let targetElementId = targetElement.getAttribute("id");
      let errorEelementDiv = rmoFormSelection.querySelector("."+targetElementId+"-error");
      if(errorEelementDiv){
        errorEelementDiv.classList.remove("d-none");
      }
      if(attribute && errorEelementDiv) {
        errorEelementDiv.innerText = errorEelementDiv.getAttribute(attribute)
      }
    }
    rmoGlobalElementObject.hideValidationMessage  = function  (targetElement) {
      targetElement.parentNode.classList.remove('wu-input__error');
      let targetElementId = targetElement.getAttribute("id");
      let errorEelementDiv = rmoFormSelection.querySelector("."+targetElementId+"-error");
      if(errorEelementDiv){
        errorEelementDiv.classList.add("d-none");
      }
    }
    rmoGlobalElementObject.onKeyPressEventOfInputFields  = function  (event) {
      let elementId = event.currentTarget.id;
      if(elementId === 'moneyOrderNumber' || elementId === 'moneyOrderAmount') return;
      let elementObject = document.getElementById(elementId);
      rmoGlobalElementObject.hideValidationMessage(elementObject);
    }
    rmoGlobalElementObject.onClickReasonForRequest  = function  (event) {
      let errorEelementDiv = rmoFormSelection.querySelector(".reasonForRequest-error");
      if(errorEelementDiv){
        errorEelementDiv.classList.add("d-none");
      }
    }
    rmoGlobalElementObject.triggerValidation  = function  (event) {

      let preferredLanguageEl =  rmoFormSelection.querySelector("#rmo_prefered_language");
      let datePurchasedEL =  rmoFormSelection.querySelector("#datePurchased");
      let moneryOrderPayeeNameEL =  rmoFormSelection.querySelector("#moneryOrderPayeeName");
      let locationNameEL =  rmoFormSelection.querySelector("#locationName");
      let purchasedAddressEL =  rmoFormSelection.querySelector("#purchasedAddress");
      let purchasedCityEL =  rmoFormSelection.querySelector("#purchasedCity");
      let purchasedStateEL =  rmoFormSelection.querySelector("#purchasedState");
      let purchasedZipEL =  rmoFormSelection.querySelector("#purchasedZip");
      let purchaserFirstNameEL =  rmoFormSelection.querySelector("#purchaserFirstName");
      let purchaserLastNameEL = rmoFormSelection.querySelector("#purchaserLastName");
      let purchaserEmailEL =  rmoFormSelection.querySelector("#purchaserEmail");
      let purchaserPhoneEl = rmoFormSelection.querySelector("#purchaserPhone");
      let purchaserStreetAddressEl = rmoFormSelection.querySelector("#purchaserStreetAddress");
      let purchaserCityEl = rmoFormSelection.querySelector("#purchaserCity");
      let purchaserStateEl = rmoFormSelection.querySelector("#purchaserState");
      let purchaserZipEl = rmoFormSelection.querySelector("#purchaserZip");
      let reasonForRequestEl = document.getElementsByName('reasonForRequest');
      let consentCheckBoxEl = rmoFormSelection.querySelector('input[name="consentCheckBox"]');
      let signNameEl = rmoFormSelection.querySelector("#signName");
      let signDateEl = rmoFormSelection.querySelector("#signDate");
      let humanKeyEL = rmoFormSelection.querySelector("#humanKey");
      let mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      
      let isFormValid = true;
      let returnObject = {};
     
      if(humanKeyEL){
        rmoGlobalElementObject.hideValidationMessage(humanKeyEL);
        let capatchValue = humanKeyEL.value;
        returnObject['humanKey'] = capatchValue;
        if(capatchValue !== undefined  && capatchValue == ""){
          rmoGlobalElementObject.showValidationMessage(humanKeyEL);
          //isFormValid = false;
        }else{
          returnObject['humanKey'] = capatchValue;
        }
      }
      if(signDateEl){
        rmoGlobalElementObject.hideValidationMessage(signDateEl);
        let signDate = signDateEl.value;
        if(signDate !== undefined  && signDate == ""){
          rmoGlobalElementObject.showValidationMessage(signDateEl);
          isFormValid = false;
          signDateEl.focus();
        }else{
          returnObject['signDate'] = signDate;
        }
      }
      if(signNameEl){
        rmoGlobalElementObject.hideValidationMessage(signNameEl);
        let signName = signNameEl.value;
        if(signName !== undefined  && signName == ""){
          rmoGlobalElementObject.showValidationMessage(signNameEl);
          isFormValid = false;
          signDateEl.focus();
        }else{
          returnObject['signName'] = signName;
        }
      }
      if(consentCheckBoxEl){
        rmoGlobalElementObject.hideValidationMessage(consentCheckBoxEl);
        let consentCheckBox = consentCheckBoxEl.checked;
        if(consentCheckBox !== undefined  && consentCheckBox != true){
          rmoGlobalElementObject.showValidationMessage(consentCheckBoxEl);
          isFormValid = false;
          consentCheckBoxEl.focus();
        }else{
          returnObject['consentCheckBox'] = consentCheckBox;
        }
      }
      let selectedFilesArray = rmoGlobalElementObject.fileArray;
      if(selectedFilesArray){
        let uploadFileEl = rmoFormSelection.querySelector("#rmoUploadFiles");
        if(selectedFilesArray.length == 0){
          
          rmoGlobalElementObject.showValidationMessage(uploadFileEl); 
          uploadFileEl.parentNode.classList.add("wu-dropzone-error");
          isFormValid = false;
          uploadFileEl.focus();
        }else {
          rmoGlobalElementObject.showValidationMessage(uploadFileEl); 
          uploadFileEl.parentNode.classList.remove("wu-dropzone-error");
        }
      }

      if(reasonForRequestEl){
       // rmoGlobalElementObject.hideValidationMessage(reasonForRequestEl);
       let errorEelementDiv = rmoFormSelection.querySelector(".reasonForRequest-error");
        if(errorEelementDiv){
          errorEelementDiv.classList.add("d-none");
        }
        var radioButtonClicked = false;
        var i = 0;
        let reasonForRequest="";
        while (!radioButtonClicked && i < reasonForRequestEl.length) {
            if (reasonForRequestEl[i].checked){
              radioButtonClicked = true;
              reasonForRequest = reasonForRequestEl[i].value;
            } 
            i++;        
        }
        
        if(reasonForRequest !== undefined  && reasonForRequest == ""){
          if(errorEelementDiv){
            errorEelementDiv.classList.remove("d-none");
          }
          isFormValid = false;
          errorEelementDiv.focus();
        }else{
          returnObject['reasonForRequest'] = reasonForRequest;
        }
      }

      if(purchaserZipEl){
        rmoGlobalElementObject.hideValidationMessage(purchaserZipEl);
        let purchaserZip = purchaserZipEl.value;
        if(purchaserZip !== undefined  && purchaserZip == ""){
          rmoGlobalElementObject.showValidationMessage(purchaserZipEl);
          isFormValid = false;
          purchaserZipEl.focus();
        }else{
          returnObject['purchaserZip'] = purchaserZip;
        }
      }
      if(purchaserStateEl){
        rmoGlobalElementObject.hideValidationMessage(purchaserStateEl);
        let purchaserState = purchaserStateEl.value;
        if(purchaserState !== undefined  && purchaserState == ""){
          rmoGlobalElementObject.showValidationMessage(purchaserStateEl);
          isFormValid = false;
          purchaserStateEl.focus();
        }else{
          let stateKeyValue = purchaserStateEl.getAttribute("data-keyvalue");
          returnObject['purchaserState'] = stateKeyValue;
        }
      }
      if(purchaserCityEl){
        rmoGlobalElementObject.hideValidationMessage(purchaserCityEl);
        let purchaserCity = purchaserCityEl.value;
        if(purchaserCity !== undefined  && purchaserCity == ""){
          rmoGlobalElementObject.showValidationMessage(purchaserCityEl);
          isFormValid = false;
          purchaserCityEl.focus();
        }else{
          returnObject['purchaserCity'] = purchaserCity;
        }
      }
      if(purchaserStreetAddressEl){
        rmoGlobalElementObject.hideValidationMessage(purchaserStreetAddressEl);
        let purchaserStreetAddress = purchaserStreetAddressEl.value;
        if(purchaserStreetAddress !== undefined  && purchaserStreetAddress == ""){
          rmoGlobalElementObject.showValidationMessage(purchaserStreetAddressEl);
          isFormValid = false;
          purchaserStreetAddressEl.focus();
        }else{
          returnObject['purchaserStreetAddress'] = purchaserStreetAddress;
        }
      }
      if(purchaserPhoneEl){
        rmoGlobalElementObject.hideValidationMessage(purchaserPhoneEl);
        let purchaserPhone = purchaserPhoneEl.value;
        if(purchaserPhone !== undefined  && purchaserPhone == ""){
          rmoGlobalElementObject.showValidationMessage(purchaserPhoneEl);
          isFormValid = false;
          purchaserPhoneEl.focus();
        }else{
          returnObject['purchaserPhone'] = purchaserPhone;
        }
      }
      if(purchaserEmailEL){
        rmoGlobalElementObject.hideValidationMessage(purchaserEmailEL);
        let purchaserEmail = purchaserEmailEL.value;
        if(purchaserEmail !== undefined  && purchaserEmail == ""){
          rmoGlobalElementObject.showValidationMessage(purchaserEmailEL);
          isFormValid = false;
          purchaserPhoneEl.focus();
        }else{
          returnObject['purchaserEmail'] = purchaserEmail;
        }
      }
      if(purchaserLastNameEL){
        rmoGlobalElementObject.hideValidationMessage(purchaserLastNameEL);
        let purchaserLastName = purchaserLastNameEL.value;
        if(purchaserLastName !== undefined  && purchaserLastName == ""){
          rmoGlobalElementObject.showValidationMessage(purchaserLastNameEL);
          isFormValid = false;
          purchaserLastNameEL.focus();
        }else{
          returnObject['purchaserLastName'] = purchaserLastName;
        }
      }

      if(purchaserFirstNameEL){
        rmoGlobalElementObject.hideValidationMessage(purchaserFirstNameEL);
        let purchaserFirstName = purchaserFirstNameEL.value;
        if(purchaserFirstName !== undefined  && purchaserFirstName == ""){
          rmoGlobalElementObject.showValidationMessage(purchaserFirstNameEL);
          isFormValid = false;
          purchaserFirstNameEL.focus();
        }else{
          returnObject['purchaserFirstName'] = purchaserFirstName;
        }
      }

      if(purchasedZipEL){
        rmoGlobalElementObject.hideValidationMessage(purchasedZipEL);
        let purchasedZip = purchasedZipEL.value;
        if(purchasedZip !== undefined  && purchasedZip == ""){
          rmoGlobalElementObject.showValidationMessage(purchasedZipEL);
          isFormValid = false;
          purchasedZipEL.focus();
        }else{
          returnObject['purchasedZip'] = purchasedZip;
        }
      }

      if(purchasedStateEL){
        rmoGlobalElementObject.hideValidationMessage(purchasedStateEL);
        let purchasedState = purchasedStateEL.value;
        if(purchasedState !== undefined  && purchasedState == ""){
          rmoGlobalElementObject.showValidationMessage(purchasedStateEL);
          isFormValid = false;
          purchasedStateEL.focus();
        }else{
          let purchasedStateKeyValue = purchasedStateEL.getAttribute("data-keyvalue");
          returnObject['purchasedState'] = purchasedStateKeyValue;
        }
      }

      if(purchasedCityEL){
        rmoGlobalElementObject.hideValidationMessage(purchasedCityEL);
        let purchasedCity = purchasedCityEL.value;
        if(purchasedCity !== undefined  && purchasedCity == ""){
          rmoGlobalElementObject.showValidationMessage(purchasedCityEL);
          isFormValid = false;
          purchasedCityEL.focus();
        }else{
          returnObject['purchasedCity'] = purchasedCity;
        }
      }

      if(purchasedAddressEL){
        rmoGlobalElementObject.hideValidationMessage(purchasedAddressEL);
        let purchasedAddress = purchasedAddressEL.value;
        if(purchasedAddress !== undefined  && purchasedAddress == ""){
          rmoGlobalElementObject.showValidationMessage(purchasedAddressEL);
          isFormValid = false;
          purchasedAddressEL.focus();
        }else{
          returnObject['purchasedAddress'] = purchasedAddress;
        }
      }

      if(locationNameEL){
        rmoGlobalElementObject.hideValidationMessage(locationNameEL);
        let locationName = locationNameEL.value;
        if(locationName !== undefined  && locationName == ""){
          rmoGlobalElementObject.showValidationMessage(locationNameEL);
          isFormValid = false;
          locationNameEL.focus();
        }else{
          returnObject['locationName'] = locationName;
        }
      }

      if(moneryOrderPayeeNameEL){
        rmoGlobalElementObject.hideValidationMessage(moneryOrderPayeeNameEL);
        let moneryOrderPayeeName = moneryOrderPayeeNameEL.value;
        if(moneryOrderPayeeName !== undefined  && moneryOrderPayeeName == ""){
          rmoGlobalElementObject.showValidationMessage(moneryOrderPayeeNameEL);
          isFormValid = false;
          moneryOrderPayeeNameEL.focus();
        }else{
          returnObject['moneryOrderPayeeName'] = moneryOrderPayeeName;
        }
      }

      if(datePurchasedEL){
        rmoGlobalElementObject.hideValidationMessage(datePurchasedEL);
        let datePurchased = datePurchasedEL.value;
        if(datePurchased !== undefined  && datePurchased == ""){
          rmoGlobalElementObject.showValidationMessage(datePurchasedEL);
          isFormValid = false;
          datePurchasedEL.focus();
        }else{
          returnObject['datePurchased'] = datePurchased;
        }
      }

      if(moneyOrderAmountEL){
        rmoGlobalElementObject.hideValidationMessage(moneyOrderAmountEL);
        let moneyOrderAmount = moneyOrderAmountEL.value;
        if(!(/^\d{0,6}(\.\d{0,2})?$/.test(moneyOrderAmount))){
          rmoGlobalElementObject.showValidationMessage(moneyOrderAmountEL);
          isFormValid = false;
          moneyOrderAmountEL.focus();
        }else{
          returnObject['moneyOrderAmount'] = moneyOrderAmount;
        }
      }

      if(moneyOrderNumberEL){
        rmoGlobalElementObject.hideValidationMessage(moneyOrderNumberEL);
        let moneyOrderNumber = moneyOrderNumberEL.value;
        if(!(/^\d+$/.test(moneyOrderNumber))){
          rmoGlobalElementObject.showValidationMessage(moneyOrderNumberEL, 'number-only-error-message');
          isFormValid = false;
          moneyOrderNumberEL.focus();
        } else if(moneyOrderNumber.length !== 11) {
          rmoGlobalElementObject.showValidationMessage(moneyOrderNumberEL, 'min-max-error-message');
          isFormValid = false;
          moneyOrderNumberEL.focus();
        }else{
          returnObject['moneyOrderNumber'] = moneyOrderNumber;
        }
      }

     
      
      console.log('Validation Event Triggered-- Status='+isFormValid);
      if(isFormValid == true){
        returnObject['status'] = "success";
      }else{
        returnObject['status'] = "error";
      }
      
      if(preferredLanguageEl){
        let preferredLanguage = preferredLanguageEl.value;
        returnObject['preferredLanguage'] = preferredLanguage.toLowerCase();
      }else{
        returnObject['preferredLanguage'] = "english";
      }

      return returnObject;
    }
    rmoGlobalElementObject.fileArray = [];
    rmoGlobalElementObject.fileBase64Array = [];
    rmoGlobalElementObject.handleFileUploadEvent = function  (evt) {
      let uploadFileExtErorEl = rmoFormSelection.querySelector(".rmoUploadFiles-format-error"); 
      uploadFileExtErorEl.classList.add('d-none');
      let currentSelectedFiles = Array.from(evt.target.files);
      for(let i=0;i<currentSelectedFiles.length;i++){
        let fileObject = currentSelectedFiles[i];
        if(rmoGlobalElementObject.isValidFileExtension(fileObject)){
          rmoGlobalElementObject.fileArray.push(fileObject);
        }else {
          uploadFileExtErorEl.classList.remove('d-none');
        }
         
      }
      rmoGlobalElementObject.addFileListUIelement();
      console.log('file Upload Event Triggered');
      let uploadFileEl = rmoFormSelection.querySelector("#rmoUploadFiles"); 
      rmoGlobalElementObject.hideValidationMessage(uploadFileEl); 
      uploadFileEl.parentNode.classList.remove("wu-dropzone-error");
    }
    rmoGlobalElementObject.getFileName = function(fileObject){
      let size=0;
      let fileName = "" ;
      if(fileObject.size>1000000){
          size=(fileObject.size/1024)/1024
         return  fileName = fileObject.name+" "+size.toFixed(2)+" MB ";

      }else{
          size=fileObject.size/1024
         return fileName = fileObject.name+" "+size.toFixed(2)+" KB ";

       }
    }
    rmoGlobalElementObject.getFileSizeInLimit = function(){
      let totalsize=0;
      for(let i=0;i<rmoGlobalElementObject.fileArray.length;i++){
        let fileObject = rmoGlobalElementObject.fileArray[i];
        totalsize+=fileObject.size;
      }
      if(totalsize>1000000){
         let size=(totalsize/1024)/1024;
          if(size > 25){
            return false;
          }else {
            return true;
          }
      }else{
         return true;
       }
    }
    rmoGlobalElementObject.isValidFileExtension = function(fileObject){
      let fileExtension = fileObject.name.split('.').pop();
      let rmoFormSupportedExtentions = ['doc', 'docx' ,'pdf' ,'jpeg', 'jpg', 'heic'];
      if(rmoFormSupportedExtentions.indexOf(fileExtension.toLowerCase()) === -1){
        return false;
      }else {
        return true;
      }
    }
    rmoGlobalElementObject.removeUploadedFile = function(fileName){
      let tempArray = rmoGlobalElementObject.fileArray;
      rmoGlobalElementObject.fileArray = [];
      for(let i=0;i<tempArray.length;i++){
        let fileObject = tempArray[i];
        if(rmoGlobalElementObject.getFileName(fileObject) == fileName){
           console.log('remove file found..');
        } else {
          rmoGlobalElementObject.fileArray.push(fileObject);
        }  
      }
      rmoGlobalElementObject.addFileListUIelement();
    }
    rmoGlobalElementObject.addFileListUIelement = function(){
      let fileUielements="";
      let uploadFileSizeErrorEl =  rmoFormSelection.querySelector(".rmoUploadFiles-size-error");
      uploadFileSizeErrorEl.classList.add('d-none');
      for(let i=0;i<rmoGlobalElementObject.fileArray.length;i++){
        let fileObject = rmoGlobalElementObject.fileArray[i];
        let fileName = rmoGlobalElementObject.getFileName(fileObject);
        fileUielements+= '<span class="wu-label wu-lable-info bk-inactive font-body-xxs mar-xs-rt">'+fileName+'<button title="Remove" class="wu-filter-remove" type="button" onclick="rmoGlobalElementObject.removeUploadedFile(\''+fileName+'\');">x</button></span>';
      }
      let fileListContainerEl = rmoFormSelection.querySelector("#fileListContainer");
      fileListContainerEl.innerHTML = fileUielements;
      if(rmoGlobalElementObject.fileArray.length == 0){
        var rmoUploadEL =  rmoFormSelection.querySelector("#rmoUploadFiles");
        rmoUploadEL.value = "";
      }else if(rmoGlobalElementObject.getFileSizeInLimit() == false){  
        uploadFileSizeErrorEl.classList.remove('d-none');
      }
    }
    rmoGlobalElementObject.verfiyCaptcha = function(recaptcha_response){
      document.getElementById("humanKey").value = recaptcha_response;
      console.log(recaptcha_response);
    }
    rmoGlobalElementObject.initateSubmitApi = async function(fromObject){
      let docFiles = [];
      let requestPayLoad = fromObject;
      let selectedFilesArray = rmoGlobalElementObject.fileArray;
      if(selectedFilesArray){
        let uploadFileEl = rmoFormSelection.querySelector("#rmoUploadFiles");
        if(selectedFilesArray.length == 0){
          
          rmoGlobalElementObject.showValidationMessage(uploadFileEl); 
          uploadFileEl.parentNode.classList.add("wu-dropzone-error");
          return false;
        }else {
          rmoGlobalElementObject.showValidationMessage(uploadFileEl); 
          uploadFileEl.parentNode.classList.remove("wu-dropzone-error");
        }
        for(let i=0;i<selectedFilesArray.length;i++){
          let fileObject = selectedFilesArray[i]
          let reader = new FileReader();
          reader.readAsDataURL(fileObject);
          reader.onload = function () {
            const base64String = reader.result.replace('data:', '').replace(/^.+,/, '');
            let uploadData = {
                "fileName": fileObject.name,
                "data": base64String,
            }
            docFiles.push(uploadData);
            if(docFiles.length == selectedFilesArray.length){
              requestPayLoad["docFiles"] = docFiles;
              rmoGlobalElementObject.triggerSubmitApi(fromObject);
              
            }
          }
         }
      } else {
        //show file upload error...
      }
      
    }
    rmoGlobalElementObject.showSpinner = function(){
      var showSpinnerBkgroundEl =  document.querySelector(".wu-spinner-overlay");
      var showSpinnerContainerEl =  document.querySelector(".wu-spinner");
      showSpinnerBkgroundEl.classList.remove('d-none');
      showSpinnerContainerEl.classList.remove('d-none');
    }
    rmoGlobalElementObject.hideSpinner = function(){
      var showSpinnerBkgroundEl =  document.querySelector(".wu-spinner-overlay");
      var showSpinnerContainerEl =  document.querySelector(".wu-spinner");
      showSpinnerBkgroundEl.classList.add('d-none');
      showSpinnerContainerEl.classList.add('d-none');
    }
    rmoGlobalElementObject.resetCaptcha = function(){
      var showSpinnerBkgroundEl =  rmoFormSelection.querySelector("#humanKey");
      showSpinnerBkgroundEl.value="";
      if(grecaptcha){
        grecaptcha.reset();
      }
    }
    rmoGlobalElementObject.triggerSubmitApi = async function(formObject){
      rmoGlobalElementObject.showSpinner();
      let serviceURl = "https://www3.westernunion.com/wuconnect/dcaas/caas-config/v1/initiateSSF/postRMOForm";
      if (window.location.hostname == 'www2.westernunion.com') {
          serviceURl =  "https://www2.westernunion.com/wuconnect/dcaas/caas-config/v1/initiateSSF/postRMOForm";
        }
      else if (window.location.hostname == 'www.westernunion.com') {
        serviceURl = "https://www.westernunion.com/wuconnect/dcaas/caas-config/v1/initiateSSF/postRMOForm";
      }  
      let tempObject = {};
      tempObject["humanKey"] = formObject["humanKey"];
      tempObject["ownerId"] ="00G6O000004d9nRUAQ";
      tempObject["moneyOrder"] =formObject["moneyOrderNumber"];
      tempObject["amount"] =formObject["moneyOrderAmount"];
      tempObject["purchasedDate"] =formObject["datePurchased"];
      tempObject["payableTo"] =formObject["moneryOrderPayeeName"];
      tempObject["purchaseLocationName"] = formObject["locationName"];
      tempObject["purchaseLocationAddress"] = formObject["purchasedAddress"];
      tempObject["purchaseLocationCity"] = formObject["purchasedCity"];
      tempObject["purchaseLocationState"] = formObject["purchasedState"];
      tempObject["purchaseLocationPostalCode"] = formObject["purchasedZip"];
      tempObject["firstName"] = formObject["purchaserFirstName"];
      tempObject["lastName"] = formObject["purchaserLastName"];
      tempObject["email"] = formObject["purchaserEmail"];
      tempObject["telephone"]=formObject["purchaserPhone"];
      tempObject["street"]=formObject["purchaserStreetAddress"];
      tempObject["city"]=formObject["purchaserCity"];
      tempObject["state"]=formObject["purchaserState"];
      tempObject["zip"]=formObject["purchaserZip"];
      tempObject["reasonForRequest"]=formObject["reasonForRequest"];
      tempObject["consent"]="true";
      tempObject["signature"]=formObject["signName"];
      tempObject["signatureDate"]=formObject["signDate"];
      tempObject["preferredLanguage"]=formObject["preferredLanguage"];
      tempObject["comments"]="Money Order Was Purchased At "+formObject["locationName"]+","+formObject["purchasedAddress"]+","+formObject["purchasedCity"]+","+formObject["purchasedState"]+","+formObject["purchasedZip"]; 
      tempObject["suppliedComments"]=formObject["reasonForRequest"]+" Money Order "+formObject["signName"]+" Provided Consent to RMO Refund Request Terms and Conditions on "+formObject["signDate"];
      
      //tempObject["recordTypeIdEnabled"]="Y";
      tempObject["docFiles"] = formObject["docFiles"];

      let requestPayload = tempObject;
      var xhr = new XMLHttpRequest();
      xhr.open("POST", serviceURl);
      xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      xhr.onreadystatechange = function () {
        rmoGlobalElementObject.hideSpinner();
          if (xhr.readyState == 4 && xhr.status == 200) {
               console.log('success');
               rmoGlobalElementObject.showSubmitSuccessMessageFromApiResponse(xhr.responseText) 
          }
         
         console.log(xhr);
      };
      xhr.send(JSON.stringify(requestPayload));
    }
    rmoGlobalElementObject.showSubmitSuccessMessageFromApiResponse = function  (response) {
      console.log(response);
      var caseNumbeEl =  rmoFormSelection.querySelector(".rmoSubmitButton-error");
      let caseNumber = "";
      let parsedResponse = JSON.parse(response);
      if(parsedResponse && parsedResponse['compositeResponse'] && parsedResponse['compositeResponse'].length >1){
        let responseArray = parsedResponse['compositeResponse'];
        if(responseArray[1].httpStatusCode == 200 && responseArray[1].referenceId == "ref_case_query"){
          if(responseArray[1]['body'] && responseArray[1]['body']['CaseNumber']){
            caseNumber = responseArray[1]['body']['CaseNumber'];
            rmoGlobalElementObject.openMessageOverlay();
            var caseNumbeEl =  document.querySelector("#caseNumbeEl");
            if(caseNumbeEl){
              caseNumbeEl.innerText=caseNumber;
            }           
          }
        } else {
          rmoGlobalElementObject.resetCaptcha();
          caseNumbeEl.classList.remove('d-none');
          
        }
      }    
   }
    rmoGlobalElementObject.rmoFormCancelEventHandler = function  (event) {
      rmoGlobalElementObject.openWuHelpCenter();
    }
    rmoGlobalElementObject.rmoFormSubmitEventHandler  = function  (event) {
        console.log('Submit Event Triggered');
        let validatedFormObject = rmoGlobalElementObject.triggerValidation();
        if(validatedFormObject['status'] == "success"){
          rmoGlobalElementObject.initateSubmitApi(validatedFormObject);
        }
        
        console.log(validatedFormObject);
    }
    rmoGlobalElementObject.openMessageOverlay = function() {
      var overLayContainer = document.querySelector('.wu-overlay');
      overLayContainer.style.display ="flex";
    }
    rmoGlobalElementObject.openWuHelpCenter = function() {
      var win = window.open('https://wucare.westernunion.com/s/customer-care-home?language=en_US',"_self");
      win.focus()
    }
    const setButtonEventListeners  = function  (event) {
        var rmoCancelButtonElement =  rmoFormSelection.querySelector("#rmoCancelButton");
        var rmoSubmitButtonElement =  rmoFormSelection.querySelector("#rmoSubmitButton");
       
        
        rmoCancelButtonElement.addEventListener("click", function() { 
            rmoGlobalElementObject.rmoFormCancelEventHandler(event); 
        });
    
        rmoSubmitButtonElement.addEventListener("click", function() { 
            rmoGlobalElementObject.rmoFormSubmitEventHandler(event); 
        });
        
    }
    const loadrmoDefaultForm = () => {
        setDropDownEventListeners();
        setButtonEventListeners();
        setDatePickers();
       
    }
    let rmo_COUNTRY_LIST = {
      "AD": "Andorra",
      "AE": "United Arab Emirates",
      "AF": "Afghanistan",
      "AG": "Antigua And Barbuda",
      "AI": "Anguilla",
      "AL": "Albania",
      "AM": "Armenia",
      "AO": "Angola",
      "B1": "Bonaire",
      "AR": "Argentina",
      "AS": "American Samoa",
      "AT": "Austria",
      "AU": "Australia",
      "AW": "Aruba",
      "AZ": "Azerbaijan",
      "BB": "Barbados",
      "BD": "Bangladesh",
      "BE": "Belgium",
      "BF": "Burkina Faso",
      "BG": "Bulgaria",
      "BH": "Bahrain",
      "BI": "Burundi",
      "BJ": "Benin",
      "BL": "Saint Barthelemy",
      "BM": "Bermuda",
      "BN": "Brunei Darussalam",
      "BO": "Bolivia",
      "BA": "Bosnia and Herzegovina",
      "BR": "Brazil",
      "BS": "Bahamas",
      "BT": "Bhutan",
      "BW": "Botswana",
      "BY": "Belarus",
      "BZ": "Belize",
      "CA": "Canada",
      "CF": "Central African Republic",
      "CH": "Switzerland",
      "CI": "Ivory Coast",
      "CK": "Cook Islands",
      "CL": "Chile",
      "CM": "Cameroon",
      "CN": "China",
      "CO": "Colombia",
      "CR": "Costa Rica",
      "CU": "Cuba",
      "CV": "Cape Verde",
      "CW": "Curacao",
      "CY": "Cyprus",
      "CZ": "Czech Republic",
      "DE": "Germany",
      "DJ": "Djibouti",
      "DK": "Denmark",
      "DM": "Dominica",
      "DO": "Dominican Republic",
      "DZ": "Algeria",
      "EC": "Ecuador",
      "EE": "Estonia",
      "SWZ": "Eswatini",
      "EG": "Egypt",
      "ER": "Eritrea",
      "ES": "Spain",
      "ET": "Ethiopia",
      "FI": "Finland",
      "FK": "Falkland Islands (Malvinas)",
      "FJ": "Fiji",
      "FM": "Micronesia",
      "FR": "France",
      "GA": "Gabon",
      "GB": "United Kingdom",
      "GD": "Grenada",
      "GE": "Georgia",
      "GF": "French Guiana",
      "GH": "Ghana",
      "GI": "Gibraltar",
      "GL": "Greenland",
      "GM": "Gambia",
      "GN": "Guinea",
      "GP": "Guadeloupe",
      "GQ": "Equatorial Guinea",
      "GR": "Greece",
      "GT": "Guatemala",
      "GU": "Guam",
      "GW": "Guinea-Bissau",
      "GY": "Guyana",
      "HK": "Hong Kong",
      "HN": "Honduras",
      "HR": "Croatia",
      "HT": "Haiti",
      "HU": "Hungary",
      "ID": "Indonesia",
      "IE": "Ireland",
      "IL": "Israel",
      "IN": "India",
      "IQ": "Iraq",
      "IR": "Iran",
      "IS": "Iceland",
      "IT": "Italy",
      "JM": "Jamaica",
      "JO": "Jordan",
      "JP": "Japan",
      "K1": "Kosovo",
      "KE": "Kenya",
      "KG": "Kyrghyz Republic",
      "KH": "Cambodia",
      "KI": "Kiribati",
      "KM": "Comoros",
      "CG": "Congo",
      "KN": "Saint Kitts And Nevis",
      "KW": "Kuwait",
      "KY": "Cayman Islands",
      "KZ": "Kazakhstan",
      "LA": "Laos",
      "LB": "Lebanon",
      "LC": "Saint Lucia",
      "LI": "Liechtenstein",
      "LK": "Sri Lanka",
      "LR": "Liberia",
      "LS": "Lesotho",
      "LT": "Lithuania",
      "LU": "Luxembourg",
      "LV": "Latvia",
      "LY": "Libya",
      "MA": "Morocco",
      "MC": "Monaco",
      "MD": "Moldova",
      "ME": "Montenegro",
      "MF": "St. Martin",
      "MG": "Madagascar",
      "MH": "Marshall Islands",
      "MK": "Macedonia",
      "ML": "Mali",
      "MM": "Myanmar",
      "MN": "Mongolia",
      "MO": "Macau",
      "MP": "Northern Mariana Islands",
      "MQ": "Martinique",
      "MR": "Mauritania",
      "MS": "Montserrat",
      "MT": "Malta",
      "MU": "Mauritius",
      "MV": "Maldives",
      "MW": "Malawi",
      "MX": "Mexico",
      "MY": "Malaysia",
      "MZ": "Mozambique",
      "NA": "Namibia",
      "NC": "New Caledonia",
      "NE": "Niger",
      "NG": "Nigeria",
      "NI": "Nicaragua",
      "NL": "Netherlands",
      "NO": "Norway",
      "NP": "Nepal",
      "NR": "Nauru",
      "NU": "Niue",
      "NZ": "New Zealand",
      "OM": "Oman",
      "PA": "Panama",
      "PE": "Peru",
      "PF": "French Polynesia",
      "PG": "Papua New Guinea",
      "PH": "Philippines",
      "PK": "Pakistan",
      "PL": "Poland",
      "PR": "Puerto Rico",
      "PS": "Palestinian Authority",
      "PT": "Portugal",
      "PW": "Palau",
      "PY": "Paraguay",
      "QA": "Qatar",
      "KR": "Republic of Korea",
      "RE": "Reunion Island",
      "RO": "Romania",
      "S1": "St. Maarten",
      "RS": "Serbia",
      "RU": "Russia",
      "RW": "Rwanda",
      "SA": "Saudi Arabia",
      "SB": "Solomon Islands",
      "SC": "Seychelles",
      "SD": "Sudan",
      "SE": "Sweden",
      "SG": "Singapore",
      "SI": "Slovenia",
      "SK": "Slovakia",
      "SL": "Sierra Leone",
      "SN": "Senegal",
      "SO": "Somalia",
      "SR": "Suriname",
      "SS": "South Sudan",
      "SV": "El Salvador",
      "SY": "Syria",
      "SZ": "Swaziland",
      "TC": "Turks and Caicos Islands",
      "TD": "Chad",
      "TG": "Togo",
      "TH": "Thailand",
      "TL": "Timor-Leste",
      "TK": "Tokelau",
      "TJ": "Tajikistan",
      "TM": "Turkmenistan",
      "TN": "Tunisia",
      "TO": "Tonga",
      "TR": "Turkey",
      "TT": "Trinidad and Tobago",
      "TV": "Tuvalu",
      "TW": "Taiwan",
      "TZ": "Tanzania",
      "UA": "Ukraine",
      "UG": "Uganda",
      "US": "United States",
      "UY": "Uruguay",
      "UZ": "Uzbekistan",
      "VC": "Saint Vincent And The Grenadines",
      "VE": "Venezuela",
      "VG": "British Virgin Islands",
      "VI": "Virgin Islands (US)",
      "VN": "Vietnam",
      "VU": "Vanuatu",
      "WS": "Samoa",
      "SM": "San Marino",
      "ST": "Sao Tome and Principe",
      "XD": "St. Thomas",
      "XZ": "North Ireland",
      "YE": "Yemen",
      "YT": "Mayotte",
      "ZA": "South Africa",
      "ZM": "Zambia",
      "ZW": "Zimbabwe"
    };
    if (/complete|interactive|loaded/.test(document.readyState)) {
        loadrmoDefaultForm();
    } else {
        window.addEventListener("load", loadrmoDefaultForm);
    }
}